import appStore from '../../store/appStore';

const resetEmployeeData = state => ({
  ...state,
  employee_data: { ...appStore.employee_data },
  showAddIcon: false,
  showDeleteIcon: false,
  showFamilyIcon: false,
});

const appReducer = (state, action) => {
  const { type, ...data } = action;

  switch (type) {
    case 'reset_employee_data':
      return resetEmployeeData(state);
    case 'employee_data': {
      return {...state, employee_data : {...state.employee_data, ...data}}
    }
    case 'toggle dragger click': {
      return { ...state, employee_data : { ...state.employee_data, click_dragger: !state.employee_data.click_dragger} };
    }
    default:
      if (data.companyId != null && String(data.companyId) !== String(state.companyId)) {
        return { ...resetEmployeeData(state), ...data, showSpendingAccount: false };
      }
      return { ...state, ...data };
  }
};

export default appReducer;
